import React from 'react';
import PropTypes from 'prop-types';

import { phonePropType } from 'config/propTypes';

import { Group, Row, Column } from 'components/core/Page';
import { H3, H4, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { ClickToCall } from 'components/facility/ClickToCall';

import filterImage from 'assets/images/icons/filter.svg';
import mapImage from 'assets/images/icons/map-pin.svg';

import './NoResults.scss';

export default function NoResults({ phone, actions }) {
	return (
		<div className="no-results">
			<div className="content">
				<Group>
					<H3 size="large">
						No facilities in this area.
					</H3>
					<Paragraph>
						Don't worry – we can help you get back on track.
					</Paragraph>
				</Group>
				<Row>
					<Column xlarge={6}>
						<Image
							src={filterImage}
							className="step-image"
						/>
						<Paragraph className="step-text">
							Change your filters.
						</Paragraph>
					</Column>
					<Column xlarge={6}>
						<Image
							src={mapImage}
							className="step-image"
						/>
						<Paragraph className="step-text">
							Search for a more specific location.
						</Paragraph>
					</Column>
				</Row>
			</div>
			<div className="need-help">
				<H4 size="medium">
					Need help finding the perfect storage? Give us a call!
				</H4>
				<ClickToCall
					phone={phone}
					onFetchNumber={actions.getTollfreePhoneNumber}
				/>
			</div>
		</div>
	);
}

NoResults.propTypes = {
	phone: phonePropType,
	actions: PropTypes.shape({
		getTollfreePhoneNumber: PropTypes.func.isRequired
	}).isRequired
};
